export const ALTER_ALERT = "ALTER_ALERT";
export const HIDE_ALERT = "HIDE_ALERT";
export const ALTER_ALERT_PARAM = "ALTER_ALERT_PARAM";
export const SHOW_TXN_ALERT = "SHOW_TXN_ALERT";
export const HIDE_TXN_ALERT = "HIDE_TXN_ALERT";
export const SHOW_DROPDOWN_ALERT = "SHOW_DROPDOWN_ALERT";
export const HIDE_DROPDOWN_ALERT = "HIDE_DROPDOWN_ALERT";


export const alertAlertAtion = data => ({
	type: ALTER_ALERT,
	payload: data
});

export const hideAlertAction = data => ({
	type: HIDE_ALERT
});

export const alertAlertAtionWithParam = data => ({
	type: ALTER_ALERT_PARAM,
	payload: data
});

export const showTxnLimitALert = data => ({
	type: SHOW_TXN_ALERT,
	payload: data
});

export const hideTxnLimitALert = () => ({
	type: HIDE_TXN_ALERT
});


export const showDropdownALert = () => ({
	type: SHOW_DROPDOWN_ALERT
});

export const hideDropdownALert = () => ({
	type: HIDE_DROPDOWN_ALERT
});
